import axios from "../../privateApi";

export type WaitlistSignup = { feature: "objectives"; createdAt: string };

const PATH = "users/waitlist-sign-up/objectives";

/** Null when the user has not signed up (the backend answers 204). */
export const getObjectivesWaitlistSignup = () =>
  axios
    .get<WaitlistSignup | "">(PATH)
    .then((res) => (res.status === 200 && res.data ? res.data : null));

/** No login needed. Idempotent: signing up twice keeps the first signup. */
export const joinObjectivesWaitlist = (email: string) =>
  axios.post<WaitlistSignup>(PATH, { email }).then((res) => res.data);
